import { useCallback, useMemo, useState } from 'react';

import { DataGridProps, GridSortModel, GridValidRowModel } from '@mui/x-data-grid';

export default function useSortableCollection<R extends GridValidRowModel = GridValidRowModel>() {
  const [sortModel, setSortModel] = useState<GridSortModel>();

  const onSortModelChange = useCallback<NonNullable<DataGridProps<R>['onSortModelChange']>>((model) => setSortModel(model), []);

  return useMemo(
    () => ({
      sortModel,
      onSortModelChange,
    }),
    [onSortModelChange, sortModel],
  );
}
